exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".section-header {\n\tfont-size: 25px;\n\tpadding: 20px;\n\tfont-weight: bold;\n}\n\n.in-section-header {\n\tfont-size: 18px;\n\tpadding-bottom: 15px;\n\tfont-weight: bold;\n}\n\n.section-container {\n\tposition: relative;\n\tbackground-color: #0E1C36;\n\tborder-radius: 10px;\n\tcolor: #fff;\n\tpadding: 20px;\n\tdisplay: inline-block;\n}\n\ntd {\n\tpadding-left: 15px;\n\tpadding-right: 15px;\n\tcolor: #000;\n}\n\ntd input {\n\tvertical-align: baseline;\n\tfont-size: 16px;\n\tmargin-right: 6px;\n}\n\ninput.upload {\n\tpadding-left: 0;\n\tpadding-right: 0;\n\tpadding-top: 10px;\n\tpadding-bottom: 0;\n}\n\ntextarea {\n\tfont-size: 16px;\n\twidth: 300px;\n\tpadding: 8px;\n}\n\n.valid-number {\n\tcolor: #40f94f;\n\tfont-style: italic;\n}\n\n.column-select-container {\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-ms-flex-wrap: wrap;\n\t    flex-wrap: wrap;\n}\n\n.column-select {\n\n}\n\n.file-import-section {\n\tborder: 3px solid #fff;\n\tborder-radius: 10px;\n\tmargin: 20px;\n\tpadding: 20px;\n\tcolor: #fff;\n\tbackground-color: #0E1C36;\n}\n\n.recipients-list {\n\toverflow-y: auto;\n\tmin-height: 100px;\n\tbackground-color: #fff;\n\tcolor: #000;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/file-import/file-import.component.css
// module id = 539
// module chunks = 1